const config = {
    currency:"SDA",
}

export default config
